<template>
  <div id="portfolio">
    <NavView />

    <FrontView id="front"/>
    <SkillsView />
    <ProjectView id="projects"/>
    <ContactView id="contactme"/>
  </div>
</template>

<script>
import FrontView from './components/FrontView.vue'
import ProjectView from './components/ProjectView.vue'
import ContactView from './components/ContactView.vue'
import SkillsView from './components/SkillsView.vue'
import NavView from './components/NavView.vue'/**/

export default {
  name: 'App',
  components: {
    FrontView, ProjectView, ContactView, SkillsView, NavView
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

html {
  scroll-behavior: smooth;
}
body {
  margin: 0%;
}
.ssection {
  padding: 0px 0px 0px 0px;
  overflow: hidden;
  display: block; 
  /*border: black solid;*/
}
h2 {
  font-family: Sitka Small;
  position: relative;
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  margin-top: 5%;
  white-space: nowrap;
  text-align: center;
  color: #A8703C; 
}
.h2-shadow {
  font-family: Sitka Small;
  color: #EFD6BE;
  position: absolute;
  font-style: normal;
  font-weight: bold;
  font-size: 70px;
  margin-top: 1%;
  white-space: nowrap;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}

@media screen and (max-width: 900px) {
  h2 {
    font-size: 37px;
  }
  .h2-shadow {
    font-size: 65px;
  }
}
@media screen and (max-width: 800px) {
  h2 {
    font-size: 33px;
  }
  .h2-shadow {
    font-size: 60px;
  }
}
@media screen and (max-width: 700px) {
  h2 {
    font-size: 28px;
  }
  .h2-shadow {
    font-size: 55px;
  }
}
@media screen and (max-width: 600px) {
  h2 {
    font-size: 24px;
  }
  .h2-shadow {
    font-size: 50px;
  }
}
@media screen and (max-width: 500px) {
  h2 {
    font-size: 20px;
  }
  .h2-shadow {
    font-size: 45px;
  }
}
@media screen and (max-width: 400px) {
  .h2-shadow {
    font-size: 40px;
  }
}
@media screen and (max-width: 300px) {
  .h2-shadow {
    font-size: 30px;
  }
}
@media screen and (max-width: 200px) {
  .h2-shadow {
    font-size: 20px;
  }
}
</style>
